import React, { useEffect, useState } from 'react';
import {
  HiOutlineBars3,
  HiOutlineBell,
  HiOutlineMagnifyingGlass,
  HiOutlineMoon,
  HiOutlineSun,
  HiOutlineUserCircle,
  HiOutlineXMark,
} from 'react-icons/hi2';
import { Link, Outlet, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import { useTheme } from '../context/ThemeContext';
import Sidenavbar from './Sidenavbar';

const Index = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  useEffect(() => {
    setIsMobileSidebarOpen(false);
    setIsProfileOpen(false);
    setIsNotificationOpen(false);
  }, [location.pathname]);

  return (
    <div className={`admin-shell ${isSidebarCollapsed ? 'sidebar-collapsed' : ''} ${isMobileSidebarOpen ? 'sidebar-open' : ''}`}>
      <Sidenavbar collapsed={isSidebarCollapsed} onClose={() => setIsMobileSidebarOpen(false)} />

      {isMobileSidebarOpen && (
        <button
          className="sidebar-overlay"
          type="button"
          aria-label="Close navigation"
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}

      <div className="admin-main">
        <header className="app-navbar">
          <div className="navbar-left">
            <button
              className="icon-button d-inline-flex d-lg-none"
              type="button"
              aria-label={isMobileSidebarOpen ? 'Close navigation' : 'Open navigation'}
              onClick={() => setIsMobileSidebarOpen((currentValue) => !currentValue)}
            >
              {isMobileSidebarOpen ? <HiOutlineXMark aria-hidden="true" /> : <HiOutlineBars3 aria-hidden="true" />}
            </button>

            <button
              className="icon-button d-none d-lg-inline-flex"
              type="button"
              aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              onClick={() => setIsSidebarCollapsed((currentValue) => !currentValue)}
            >
              <HiOutlineBars3 aria-hidden="true" />
            </button>

            <Link className="mobile-brand d-inline-flex d-lg-none" to="/dashboard/dash_board">
              <img src={logo} alt="Event Planet" />
            </Link>

            <div className="navbar-search d-none d-md-flex" role="search">
              <HiOutlineMagnifyingGlass aria-hidden="true" />
              <input type="search" placeholder="Search content, categories..." aria-label="Search content" />
            </div>
          </div>

          <div className="navbar-actions">
            <button className="icon-button" type="button" onClick={toggleTheme} aria-label="Toggle color theme">
              {isDarkMode ? <HiOutlineSun aria-hidden="true" /> : <HiOutlineMoon aria-hidden="true" />}
            </button>

            <div className="dropdown-shell">
              <button
                className="icon-button has-indicator"
                type="button"
                aria-label="View notifications"
                aria-expanded={isNotificationOpen}
                onClick={() => {
                  setIsNotificationOpen((currentValue) => !currentValue);
                  setIsProfileOpen(false);
                }}
              >
                <HiOutlineBell aria-hidden="true" />
              </button>

              {isNotificationOpen && (
                <div className="app-dropdown notification-dropdown">
                  <span className="dropdown-label">Notifications</span>
                  <div className="dropdown-item-block">
                    <strong>Publishing queue ready</strong>
                    <span>Draft review list is up to date.</span>
                  </div>
                  <div className="dropdown-item-block">
                    <strong>Category sync complete</strong>
                    <span>Blog categories loaded successfully.</span>
                  </div>
                </div>
              )}
            </div>

            <div className="dropdown-shell">
              <button
                className="profile-button"
                type="button"
                aria-label="Open profile menu"
                aria-expanded={isProfileOpen}
                onClick={() => {
                  setIsProfileOpen((currentValue) => !currentValue);
                  setIsNotificationOpen(false);
                }}
              >
                <span className="avatar">EP</span>
                <span className="profile-copy d-none d-sm-block">
                  <strong>Event Planet</strong>
                  <small>Admin</small>
                </span>
              </button>

              {isProfileOpen && (
                <div className="app-dropdown profile-dropdown">
                  <div className="profile-summary">
                    <HiOutlineUserCircle aria-hidden="true" />
                    <div>
                      <strong>Event Planet Admin</strong>
                      <span>Content workspace</span>
                    </div>
                  </div>
                  <Link className="dropdown-action" to="/dashboard/dash_board">
                    Dashboard
                  </Link>
                  <Link className="dropdown-action danger" to="/dashboard/logout">
                    Logout
                  </Link>
                </div>
              )}
            </div>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>

        <footer className="app-footer">
          <span>All Rights Reserved by Event Planet.</span>
          <a href="https://www.eventplanet.in">eventplanet.in</a>
        </footer>
      </div>
    </div>
  );
};

export default Index;
